import { render, staticRenderFns } from "./FamilyTypes.vue?vue&type=template&id=029c1c36&scoped=true"
import script from "./FamilyTypes.vue?vue&type=script&lang=js"
export * from "./FamilyTypes.vue?vue&type=script&lang=js"
import style0 from "./FamilyTypes.vue?vue&type=style&index=0&id=029c1c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029c1c36",
  null
  
)

export default component.exports